import React from 'react';

export default function InsightsView() {
  return (
    <div className="bg-white p-6 rounded-lg shadow-md text-center">
      <h2 className="text-2xl font-bold">Coming Soon</h2>
      <p className="text-gray-600 mt-2">This feature will be launched in the next edition.</p>
    </div>
  );
}
